module.exports = __webpack_public_path__ + "static/media/karol-podufalski.a8a8254d.jpg";